/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseSubDbTableRow
 */
export interface DatabaseSubDbTableRow {
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbTableRow
     */
    entryId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbTableRow
     */
    label?: string;
    /**
     * Ein Wert je Spalte. `null` heisst „nichts eingetragen" — das ist
     * etwas anderes als eine Null und wird auch anders dargestellt.
     * @type {Array<number>}
     * @memberof DatabaseSubDbTableRow
     */
    values?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSubDbTableRow
     */
    sum?: number;
}

/**
 * Check if a given object implements the DatabaseSubDbTableRow interface.
 */
export function instanceOfDatabaseSubDbTableRow(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSubDbTableRowFromJSON(json: any): DatabaseSubDbTableRow {
    return DatabaseSubDbTableRowFromJSONTyped(json, false);
}

export function DatabaseSubDbTableRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbTableRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryId': !exists(json, 'entryId') ? undefined : json['entryId'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'values': !exists(json, 'values') ? undefined : json['values'],
        'sum': !exists(json, 'sum') ? undefined : json['sum'],
    };
}

export function DatabaseSubDbTableRowToJSON(value?: DatabaseSubDbTableRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryId': value.entryId,
        'label': value.label,
        'values': value.values,
        'sum': value.sum,
    };
}

